/**
 * Lovbestemte minimumsbeløb for advokatens forsikring og garanti.
 *
 * Beløbene stod tidligere som tre uafhængige tekststrenge — feltetiketterne i
 * `insurancePolicyValidation.ts`, de danske afvisningsårsager i
 * `fieldValidationMessages.ts` og hjælpeteksten på forsikringssiden. Ændrede
 * satser krævede altså tre rettelser, og hjælpeteksten var den, der lettest blev
 * glemt, fordi den ikke ligger sammen med valideringen. Samme greb som
 * `IDLE_TIMER_TIMEOUT_MINUTES`: tallet står ét sted, så teksten ikke kan komme
 * til at love noget andet end reglen.
 *
 * VIGTIGT: de engelske nøgler i `REASON_TEXT_DA_SOURCE` må ikke ændres herfra.
 * De er låst af cle-compliance-api/tests/test_field_validation_reason_contract.py
 * og er API'ets ordlyd, ikke vores.
 */

/** Mindste dækning for advokatansvar. */
export const MIN_LAWYER_LIABILITY_AMOUNT = 2_500_000;

/** Mindste garantibeløb. */
export const MIN_GUARANTEE_AMOUNT = 5_000_000;

const amountFormatter = new Intl.NumberFormat("da-DK", {
  style: "currency",
  currency: "DKK",
  maximumFractionDigits: 0,
});

/** "2.500.000 kr." — med hårdt mellemrum, så beløb og enhed ikke deles over to linjer. */
export const formatRequirementAmount = (amount: number): string =>
  amountFormatter.format(amount);

export const MIN_LAWYER_LIABILITY_TEXT = formatRequirementAmount(
  MIN_LAWYER_LIABILITY_AMOUNT,
);

export const MIN_GUARANTEE_TEXT = formatRequirementAmount(MIN_GUARANTEE_AMOUNT);
